import React from 'react'
import {Row, Col, Button} from 'reactstrap';
import {Link} from 'react-router-dom'
import moment from 'moment';
import {formatCurrency} from '../utils/Strings'

export default class ReportResRow extends React.Component{
  
//  handleReserve(idx){
//    //alert(idx)
//    this.props.onCourseChoose(idx)
//  }
  renderButtons(res){
    if (res.isCanceled)
      return (
        <Col xs="auto" className="ml-auto">
        {res.statusDesc}
        </Col>
      )
    if (res.ticketSignature && (res.ticketSignature.length>0)){
      var ticketUrl=this.props.ticketUrlPath + res.ticketSignature
      var refundLink="/refund/" +res.idReservation
      return (
        <Col xs="auto" className="ml-auto">
        <a href={ticketUrl} 
          target="_blank" rel="noopener noreferrer" 
          className="btn btn-primary btn-sm" 
          role="button" 
          aria-pressed="true"
        >
          Potwierdzenie        
        </a>
        {' '}
        <Link to={refundLink} className="btn btn-secondary btn-sm">Zwrot</Link>        
        </Col>
      )
    }
  }
  renderTicketLink(signature) {
    if (signature && (signature.length>0)){
      var ticketUrl=this.props.ticketUrlPath + signature
      return (
        <Col xs="auto" className="ml-auto">
        <a href={ticketUrl} 
          target="_blank" rel="noopener noreferrer" 
          className="btn btn-primary btn-sm" 
          role="button" 
          aria-pressed="true"
        >
          Potwierdzenie        
        </a>
        </Col>
      )
    }
  }
  renderRefundButton(idReservation){
    if (idReservation>0)
      return (
        <Col xs="auto" className="ml-auto">
        <Button className="btn btn-primary btn-sm">Zwrot</Button>
        </Col>
      )
  }
  render() {
    var r=this.props.reservation;
    var strCourseDate=moment(r.startDateTime).format('YYYY-MM-DD')
    var strCourseTime=(
      <div>
        <span className="startTime">{moment(r.startDateTime).format('HH:mm')}</span>
        {'-'}
        <span className="finishTime">{moment(r.finishDateTime).format('HH:mm')}</span>
      </div>
    )    
    var strQty=''
    if (r.qtyNormal>0)
      strQty += r.qtyNormal + "N "
    if (r.qtyReduced>0)
      strQty += r.qtyReduced + "U"
    
    return (      
      <Row className="align-items-center">
        <Col md="2" xs={{size: 2, order: 1}}>
        <div className="courseDate">{moment(r.reservationDateTime).format('YYYY-MM-DD')}</div>
        <div className="courseDate">{moment(r.reservationDateTime).format('HH:mm')}</div>
        </Col>
                
        
        <Col md="2" xs={{size: 4, order: 2}}>
        <div className="town">{r.startTown}</div>
        <div className="street">{r.startAddress}</div>
        </Col>
      
        <Col md="2" xs={{size: 4, order: 3}}>
        <div className="town">{r.finishTown}</div>
        <div className="street">{r.finishAddress}</div>
        </Col>                  
        
        <Col md="2" xs={{size: 2, order: 4}}>
        <div className="courseDate">{strCourseDate}</div>
        {strCourseTime}
        </Col> 
        
        <Col md="2" xs={{size: 3, order: 5}} className="order-xs-5 companyName">{r.companyName}</Col>                
        
        <Col md="1" xs={{size: 1, order: 7}} className="order-xs-7 amount">{strQty}</Col>   
      
        <Col md="1" xs={{size: 2, order: 8}} className="price">{formatCurrency(r.totalPrice)}</Col>
        
        <Col md="2" xs={{size: 2, order: 9}} className="idRes">#{r.idReservation}</Col>        
        
        <Col md="3" xs={{size: 4, order: 6, push: 6, pull: 6}} className="order-xs-6 town">{r.lastName} {r.firstName}</Col>
                
        
        {this.renderButtons(r)}
                      
      </Row>      
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/ReportResRow.js